import { Injectable } from '@angular/core';
import { Platform, ToastController } from '@ionic/angular';
import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
@Injectable({
  providedIn: 'root'
})
export class FbmessagingService {

  topics = ['stores', 'riders', 'customers', 'admins', 'users']
  constructor(private firebasex: FirebaseX, private platform: Platform, public toast: ToastController) {


  }
  init() {
    if (this.platform.is('cordova')) {
      // this.backgroundMode.enable();
      this.firebasex.grantPermission().then(r => {
        this.firebasex.clearAllNotifications();
        // this.fcm.unsubscribeFromTopic('marketing');
        this.firebasex.getToken().then(token => {
          console.log(token);
          localStorage.setItem('fcmtoken', token);
        });
        // this.subScription.push(
        this.firebasex.onTokenRefresh().subscribe(token => {
          console.log("fcmtoken", token);
          localStorage.setItem('fcmtoken', token);
        })
        //);

        // this.subScription.push(
        this.firebasex.onMessageReceived().subscribe(data => {
          // 
          try {
            //  alert(JSON.stringify(data));
            // this.single_notification(0,data,data);
            // this.backgroundMode.wakeUp();
            console.log(data);
            if (data.messageType === "notification") {
              console.log("Notification message received");
              if (data.tap) {
                console.log("Tapped in " + data.tap);
              }
            }
          } catch (error) {
            console.log(this,error);

          }


        })
        //);
        // this.fcmSub(this.topics);
      });

    }
  }
  async fcmSub(topic: Array<string>) {

    // this.fcm.pipe(take(1)).subscribeToTopic(token);
    console.log('Subscription ', topic);

    try {

      // NO NEED TO UNSUBSCRIBE
      if(Array.isArray(topic)){
        console.log("array");
        
      }else{
        console.log("not array");
        
      }

      // await this.firebasex.unregister();
      for (let index = 0; index < topic.length; index++) {
        const element = topic[index];
        // alert("subscribed "+element);
        console.log('Subscription ', element);
        setTimeout(() => {
          if (this.platform.is('cordova')) {
            // DEBUG
            console.log('it is platform ' + JSON.stringify(this.platform.platforms()));
            // this.toast.create({ message: 'it is platform' + JSON.stringify(this.platform.platforms()),duration:5000 }).then(r => r.present());
            this.firebasex.subscribe(element).then((v) => {
              // DEBUG
              console.log('fcm subscribe', v);
              // this.toast.create({ message: 'fcm subscribed ' + element + ' ' + v ,duration:5000}).then(r => r.present());
              this.saveFCMSub(element);
            }).catch(e => {
              this.toast.create({ message: 'error fcm subscribing ' + element ,duration:5000}).then(r => r.present());
              console.log(e);
            });
          }
        }, 300 * index);


      }

    } catch (error) {
      console.log(this,error);

    }

  }
  async fcmUnSub(topic: Array<string>) {
    topic.forEach((v, i) => {
      setTimeout(() => {
        this.firebasex.unsubscribe(v);
      }, 400 * i);

    })

  }
  saveFCMSub(v: string) {
    try {
      let sub = []
      sub = JSON.parse(this.loadFCMSub());
      if (!sub) sub = [];
      sub.push(v);
      localStorage.setItem('fcmsubs', JSON.stringify(sub));
    } catch (error) {
      console.log(this,error);
      this.toast.create({ message: 'fcm subscribe login e ' + error }).then(r => r.present());
      // alert(error);
    }

  }
  loadFCMSub() {
    try {

      localStorage.getItem('fcmsubs') ? "" : localStorage.setItem('fcmsubs', "[]");
      return localStorage.getItem('fcmsubs');
    } catch (error) {
      this.toast.create({ message: 'fcm subscribe login e ' + error }).then(r => r.present());
      return '[]';
    }

  }
  clearSub() {
    localStorage.setItem('fcmsubs', "[]");
  }
}
